import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderContainerComponent } from '@kempower-nx-workspace/layout-templates';

@Component({
    selector: 'ctep-core-header',
    imports: [CommonModule, HeaderContainerComponent],
    templateUrl: './ctep-header.component.html',
    styleUrls: ['./ctep-header.component.scss']
})
export class CtepHeaderComponent {}
